document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".faq-question").forEach(function (question) {
        question.addEventListener("click", function () {
            const answer = this.nextElementSibling;
            const isOpen = answer.style.display === "block";
            answer.style.display = isOpen ? "none" : "block";
            this.classList.toggle("active", !isOpen);
        });
        question.addEventListener("keypress", function (e) {
            if (e.key === "Enter" || e.key === " ") {
                this.click();
            }
        });
    });

    document.querySelectorAll(".faq-answer").forEach(function (answerEl) {
        const fullAnswer = answerEl.textContent.trim();
        answerEl.setAttribute("data-full-answer", fullAnswer);
        const words = fullAnswer.split(/\s+/);
        if (words.length > 25) {
            const shortAnswer = words.slice(0, 25).join(" ");
            const longAnswer = words.slice(25).join(" ");
            answerEl.innerHTML =
                shortAnswer +
                '<span class="faq-ellipsis">... </span>' +
                '<a href="#" class="faq-read-more">Read more</a>' +
                '<span class="faq-long-answer" style="display:none;"> ' +
                longAnswer +
                ' <a href="#" class="faq-read-less">Read less</a>' +
                "</span>";
        } else {
            answerEl.textContent = fullAnswer;
        }
        answerEl.style.display = "none";
    });

    document.addEventListener("click", function (e) {
        // Read more
        if (e.target.classList.contains("faq-read-more")) {
            e.preventDefault();
            const answer = e.target.closest(".faq-answer");
            answer.querySelector(".faq-long-answer").style.display = "inline";
            answer.querySelector(".faq-ellipsis").style.display = "none";
            e.target.style.display = "none";
        }
        // Read less
        if (e.target.classList.contains("faq-read-less")) {
            e.preventDefault();
            const answer = e.target.closest(".faq-answer");
            const fullAnswer = answer.getAttribute("data-full-answer");
            const words = fullAnswer.split(/\s+/);
            const shortAnswer = words.slice(0, 25).join(" ");
            const longAnswer = words.slice(25).join(" ");
            answer.innerHTML =
                shortAnswer +
                '<span class="faq-ellipsis">... </span>' +
                '<a href="#" class="faq-read-more">Read more</a>' +
                '<span class="faq-long-answer" style="display:none;"> ' +
                longAnswer +
                ' <a href="#" class="faq-read-less">Read less</a>' +
                "</span>";
        }
    });
});